const setNotification = (context, notification) => {
  context.commit('SET_NOTIFICATION', { content: notification, callback: null, type: 'default' })
}

const setNotificationError = (context, notification) => {

  let content = null
  let callback = null

  if (notification) {
    if (typeof notification === 'string' || notification instanceof String) {
      content = notification
    }
    else if (typeof notification === 'object' || notification instanceof Object) {

      content = notification.content
      callback = notification.callback
    }
  }

  context.commit('SET_NOTIFICATION', { content: content, callback: callback, type: 'error' })
}

const setNotificationSuccess = (context, notification) => {
  let content = null
  let callback = null

  if (notification) {
    if (typeof notification === 'string' || notification instanceof String) {
      content = notification
    }
    else if (typeof notification === 'object' || notification instanceof Object) {

      content = notification.content
      callback = notification.callback
    }
  }

  context.commit('SET_NOTIFICATION', { content: content, callback:callback, type: 'success' })
}

const setNotificationWarning = (context, notification) => {
  let content = null
  let callback = null

  if (notification) {
    if (typeof notification === 'string' || notification instanceof String) {
      content = notification
    }
    else if (typeof notification === 'object' || notification instanceof Object) {

      content = notification.content
      callback = notification.callback
    }
  }

  context.commit('SET_NOTIFICATION', { content:content, callback:callback, type: 'orange' })
}

const setConfig = (context, config) => {
  context.commit('SET_CONFIG', config)
}

const setVersion = (context, version) => {
  context.commit('SET_VERSION', version)
}

const setResponse = (context, response) => {
  context.commit('SET_RESPONSE', response)
}

const setLocation = (context, location) => {
  context.commit('SET_LOCATION', location)
}

const setNavigation = (context, navigation) => {
  context.commit('SET_NAVIGATION', navigation)
}

const setDrawer = (context, drawer) => {
  context.commit('SET_DRAWER', drawer)
}

const setDrawerHidden = (context, drawer_hidden) => {
  context.commit('SET_DRAWER_HIDDEN', drawer_hidden)
}

export {
  setNotification,
  setNotificationError,
  setNotificationSuccess,
  setNotificationWarning,
  setConfig,
  setVersion,
  setResponse,
  setLocation,
  setNavigation,
  setDrawer,
  setDrawerHidden
}



// WEBPACK FOOTER //
// ./src/store/common/actions.js